(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clh-product-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('clh-product-story')) {
  customElements.define('clh-product-story', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const source = this.querySelector('.clh-story__source');
      const rows = [...this.querySelectorAll('.clh-story__row')];
      if (!source || !rows.length) return;
      const groups = [];
      let group = [];
      for (const node of [...source.childNodes]) {
        if (node.nodeType === 3 && !node.textContent.trim()) continue;
        if (/^H[1-6]$/.test(node.nodeName) && group.length) {
          groups.push(group);
          group = [];
        }
        group.push(node);
      }
      if (group.length) groups.push(group);
      if (groups.length === 1 && groups[0].length > 2) {
        const nodes = groups.pop();
        for (let i = 0; i < nodes.length; i += 2) groups.push(nodes.slice(i, i + 2));
      }
      const count = Math.min(rows.length, groups.length);
      groups.forEach((nodes, index) => {
        const slot = Math.min(count - 1, Math.floor(index * count / groups.length));
        if (slot >= 0) nodes.forEach(node => rows[slot].querySelector('.clh-story__copy').append(node));
      });
      rows.forEach(row => {
        if (!row.querySelector('.clh-story__copy').textContent.trim()) row.classList.add('clh-story__row--image');
      });
      source.hidden = true;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
